import {differenceInDays} from 'date-fns';

import {isEmpty, isNil} from 'ramda';

import {parseDate} from 'shared/web';

// Returns true for vehicles sold between 31-90 days ago.
// Vehicles sold within 30 days are handled by isSoldIn30Days.
// The backend filters out vehicles sold more than 90 days ago.
export function isSoldIn90Days(car: {is_sold: boolean | null; last_occurrence: string | null}) {
  if (isNil(car.last_occurrence) || isEmpty(car.last_occurrence)) {
    return false;
  }
  return !!car.is_sold && differenceInDays(new Date(), parseDate(car.last_occurrence)) > 30;
}
